import { colors } from '@/constants/colors'
import { View } from 'react-native'

/**
 * The hairline between two rows of the visit card, drawn by the lower of the two.
 *
 * Inset at both ends, as the billing rows are: theirs start where the words do, past the disc,
 * and stop at their group's own padding. These rows are full-bleed inside the card, so the right
 * inset has to be drawn rather than inherited — a rule running into the card's rounded edge
 * reads as a crack in the card.
 */
export const CardRule = () => (
	<View
		className="absolute top-0 h-px"
		style={{ left: 66, right: 16, backgroundColor: colors.divider }}
	/>
)
